export const ROLES = {
  STUDENT: "student",
  INSTRUCTOR: "instructor",
  ADMIN: "admin",
};

export const ROLE_COLORS = {
  student: "#4f46e5",
  instructor: "#f59e0b",
  admin: "#10b981",
};

